import Theme from 'Theme';

const styles = {
    container: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        margin: 'auto',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: Theme.alertTextColor,
        color: Theme.primaryTextColor,
        fontFamily: Theme.regularFont,
        zIndex: 1,
    },
    link: {
        color: Theme.primaryLinkColor,
        textDecoration: 'none',
        marginLeft: 4
    }
};

const buttonStyle = {
    button: {
        width: 43,
        maxWidth: 43,
        minWidth: 43,
        height: 26,
        padding: 0,
        margin: Theme.BU / 2
    },
    text: {
        color: Theme.primaryTextColor,
        fontSize: 15
    }
};

export { styles, buttonStyle };
